import { Flex, Box, Text } from '@chakra-ui/react';
import DetailCard from '../shared/DetailCard';
import DetailRow from '../shared/DetailRow';
import AddressValue from '../shared/AddressValue';
import { formatDate } from '../../../../utils/formatDate';

interface TransferDetailsProps {
  amount: number;
  toAccountId: string;
  fromAccountId?: string;
  createdBy?: { name: string; accountId: string };
  onCopy: (text: string) => void;
  onSaveAddress: (address: string) => void;
  expiresAt?: number;
  waitForExpiry?: boolean;
  isMultisig: boolean;
}

const TransferDetails = ({
  amount,
  toAccountId,
  fromAccountId,
  createdBy,
  onCopy,
  onSaveAddress,
  expiresAt,
  waitForExpiry,
  isMultisig,
}: TransferDetailsProps) => (
  <DetailCard>
    {fromAccountId && (
      <DetailRow label="From" value={fromAccountId} />
    )}
    <DetailRow
      label="To"
      value={
        <AddressValue address={toAccountId} onCopy={onCopy} onSave={onSaveAddress} />
      }
    />
    <DetailRow label="Amount" value={`${amount} HBAR`} />
    {createdBy && (
      <DetailRow
        label="Created by"
        value={createdBy.name ? `${createdBy.name} (${createdBy.accountId})` : createdBy.accountId}
      />
    )}
    {isMultisig && expiresAt && (
      <DetailRow
        label="Expires"
        value={
          <Flex alignItems="center" gap={2}>
            <Box px={2} py={0.5} bg="blackAlpha.50" borderRadius={4}>
              <Text size="xs" color="blackAlpha.700" whiteSpace="nowrap">
                {formatDate(expiresAt)}
              </Text>
            </Box>
            {waitForExpiry && (
              <Box px={1.5} py={0.5} bg="orange.100" borderRadius={4}>
                <Text size="xs" color="orange.700" fontWeight="600" fontSize="10px" whiteSpace="nowrap">
                  Wait for Expiry
                </Text>
              </Box>
            )}
          </Flex>
        }
      />
    )}
  </DetailCard>
);

export default TransferDetails;
